export const environment = {
  production: true,
  name: 'PROD',
  serviceUrl: 'https://portal-services.apcela.net',  // where the backend services container is running
  gtmkey: 'UA-223751485-1'
};
